import React from 'react';
import s from './s.module.less';

// UnitedHealthcare 只给 ≥20 人的 group practice 开团体合同（原型 UHC_GROUP_MIN_PROVIDERS）。
export const UHC_GROUP_MIN_PROVIDERS = 20;

// 小写 + 去空格：后端名字有 "United Healthcare"（带空格）/"UnitedHealthcare" 两种写法
const isUhcName = (name: string) => {
    const n = name.toLowerCase().replace(/\s+/g, '');
    return n.includes('unitedhealthcare') || n.includes('uhc') || n.includes('optum');
};

interface Props {
    // 当前选中的 payer 名称（任意去重程度都可以，只做 includes 判断）
    selectedPayerNames: string[];
    // 本次提交 roster 的 provider 数（不是 practice 的历史总人数）
    rosterSize: number;
}

// 蓝色 info 通知，不阻塞任何操作：选了 UHC 且 roster < 20 时出现在所有能选 UHC 的界面。
// 文案刻意不带具体人数（roster 在不同界面处于未建/在建/已定状态，数字会错或过期）；
// 每次渲染重算，roster 达标自动消失，无需可关闭状态。
const UhcGroupNotice = ({ selectedPayerNames, rosterSize }: Props) => {
    const picked = selectedPayerNames.some(isUhcName);
    if (!picked || rosterSize >= UHC_GROUP_MIN_PROVIDERS) return null;
    return (
        <div className={s.notice}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0, marginTop: 1 }}>
                <circle cx="10" cy="10" r="10" fill="#3B82F6" />
                <path
                    d="M10 9v4.5M10 6.2v.1"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            <span>
                UnitedHealthcare only opens group contracts for practices with {UHC_GROUP_MIN_PROVIDERS} or more
                providers, so it won&apos;t go through for a smaller practice. Every other payer is available at any
                size.
            </span>
        </div>
    );
};

export default UhcGroupNotice;
